import { NotificationData } from "@/types";
import { NotificationsAdminzoneState } from "@/types/store/adminzone/notification";

export const state: NotificationsAdminzoneState = {
  notifications: [] as Array<NotificationData>,
}
